import { useQuery } from '@tanstack/react-query';
import {
  FindBodyFind,
  FindBodySort,
  OperationLog,
} from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';

export const GET_DATASET_DETAILS_QUERY_KEYS = [
  '@MDH',
  'dsProxyFindApiV1DataFindPost',
] as const;

export const useGetDatasetDetails = ({
  name,
  find,
  skip,
  sort,
  limit,
  lastSuccessOperation,
}: {
  name: string | undefined;
  find?: FindBodyFind;
  skip?: number;
  sort?: FindBodySort;
  limit?: number;
  lastSuccessOperation?: OperationLog;
}) => {
  return useQuery({
    queryKey: [
      ...GET_DATASET_DETAILS_QUERY_KEYS,
      name,
      find,
      skip,
      sort,
      limit,
      lastSuccessOperation,
    ],
    queryFn: async () => {
      if (!name)
        throw new Error(
          'Error: Dataset name is required to fetch dataset details!'
        );
      return datasetApi.dsProxyFindApiV1DataFindPost(
        {
          find: find ?? {},
          dataset: name,
          skip,
          sort,
          limit,
        },
        getDatasetRequestConfig()
      );
    },
    select: res => res.data,
    enabled: Boolean(name),
  });
};
